import brazil from "../../../assets/images/abroad-photos/CGSE_Hero_Brazil.jpg";
import cameroon from "../../../assets/images/abroad-photos/CGSE_Hero_Cameroon.jpg";
import chinaBeijing from "../../../assets/images/abroad-photos/CGSE_Hero_China-Beijing.jpg";
import chinaYunnan from "../../../assets/images/abroad-photos/CGSE_Hero_China-Yunnan.jpg";
import ecuador from "../../../assets/images/abroad-photos/CGSE_Hero_EcuadorArg.jpg";
import englandHumanities from "../../../assets/images/abroad-photos/CGSE_Hero_England-Humanities.jpg";
import englandMathSci from "../../../assets/images/abroad-photos/CGSE_Hero_England-MathSci.jpg";
import englandOxford from "../../../assets/images/abroad-photos/CGSE_Hero_England-Oxford.jpg";
import france from "../../../assets/images/abroad-photos/CGSE_Hero_France.jpg";
import germany from "../../../assets/images/abroad-photos/CGSE_Hero_Germany.jpg";
import italyEuropeanStudies from "../../../assets/images/abroad-photos/CGSE_Hero_Italy-EuropeanStu.jpg";
import italianStudies from "../../../assets/images/abroad-photos/CGSE_Hero_Italy-ItalianStu.jpg";
import japan from "../../../assets/images/abroad-photos/CGSE_Hero_Japan.jpg";
import korea from "../../../assets/images/abroad-photos/CGSE_Hero_Korea.jpg";
import newZealand from "../../../assets/images/abroad-photos/CGSE_Hero_New Zealand.jpg";
import nyc from "../../../assets/images/abroad-photos/CGSE_Hero_NYC.jpg";
import russia from "../../../assets/images/abroad-photos/CGSE_Hero_Russia.jpg";
import spain from "../../../assets/images/abroad-photos/CGSE_Hero_Spain.jpg";
import washingtonDC from "../../../assets/images/abroad-photos/CGSE_Hero_Washington DC.jpg";

const programs = [
  {
    location: "Brazil",
    img: brazil,
    link:
      "https://www.dickinson.edu/homepage/1407/dickinson_in_south_america_brazil",
    description: 'The Dickinson in South American Brazil program is located at the University of São Paulo, a public university in the Brazilian state of São Paulo. It is the largest Brazilian public university and the country’s most prestigious educational institution and holds a high reputation among world universities.'
  },
  {
    location: "Cameroon",
    img: cameroon,
    link: "https://www.dickinson.edu/homepage/1408/dickinson_in_cameroon",
  },
  {
    location: "Beijing, China",
    img: chinaBeijing,
    link: "https://www.dickinson.edu/homepage/1409/dickinson_in_china_beijing",
  },
  {
    location: "Yunnan, China",
    img: chinaYunnan,
    link: "https://www.dickinson.edu/homepage/1410/dickinson_in_china_yunnan",
  },
  {
    location: "Ecuador",
    img: ecuador,
    link:
      "https://www.dickinson.edu/homepage/1412/dickinson_in_south_america_ecuador_and_argentina",
  },
  {
    location: "England",
    sub: 'Humanities',
    img: englandHumanities,
    link:
      "https://www.dickinson.edu/homepage/1402/dickinson_in_england_humanities",
  },
  {
    location: "England",
    sub:'Math & Science',
    img: englandMathSci,
    link:
      "https://www.dickinson.edu/homepage/1403/dickinson_in_england_math_and_sciences",
  },
  {
    location: "England",
    sub:'Oxford',
    img: englandOxford,
    link: "https://www.dickinson.edu/homepage/1404/dickinson_at_oxford",
  },
  {
    location: "France",
    img: france,
    link: "https://www.dickinson.edu/homepage/1405/dickinson_in_france",
  },
  {
    location: "Germany",
    img: germany,
    link: "https://www.dickinson.edu/homepage/1413/dickinson_in_germany",
  },
  {
    location: "Italy",
    sub: 'European Studies',
    img: italyEuropeanStudies,
    link:
      "https://www.dickinson.edu/homepage/1414/dickinson_in_italy_european_studies",
  },
  {
    location: "Italy",
    sub: 'Italian Studies',
    img: italianStudies,
    link:
      "https://www.dickinson.edu/homepage/1415/dickinson_in_italy_italian_studies",
  },
  {
    location: "Japan",
    img: japan,
    link: "https://www.dickinson.edu/homepage/1416/dickinson_in_japan",
  },
  {
    location: "Korea",
    img: korea,
    link: "https://www.dickinson.edu/homepage/1417/dickinson_in_korea",
  },
  {
    location: "New Zealand",
    img: newZealand,
    link: "https://www.dickinson.edu/homepage/1399/dickinson_in_new_zealand",
  },
  {
    location: "New York City, NY",
    img: nyc,
    link: "https://www.dickinson.edu/homepage/1418/dickinson_in_new_york_city",
  },
  {
    location: "Russia",
    img: russia,
    link: "https://www.dickinson.edu/homepage/1419/dickinson_in_russia",
  },
  {
    location: "Spain",
    img: spain,
    link: "https://www.dickinson.edu/homepage/1420/dickinson_in_spain",
  },
  {
    location: "Washington D.C.",
    img: washingtonDC,
    link: "https://www.dickinson.edu/homepage/1446/dickinson_in_dc",
  },
];

export default programs;
